export const updateScrollableNodeHeight = () => {
  const searchBarNode = document.querySelector('#search-bar');
  if (!searchBarNode) return;
  const searchBarRect = searchBarNode.getBoundingClientRect();

  document.documentElement.style.setProperty('--search-bar-top', `${searchBarRect.top}px`);
};
